export default "__VITE_ASSET__6itPeTel__"